import React from 'react'
import useFirestore from '../../../firebase-hooks/useFirestore'
import {motion} from 'framer-motion/dist/framer-motion'
import './Progress-Bar.scss'

const ImageGrid = ({ setSelectedImg }) => {
    const { docs } = useFirestore('images');
    console.log(docs)

  return (
    <div className="img-grid" style={{position: 'relative', left: '30%'}}>
      {/* Images */}
      {docs && docs.map(doc => (
        <motion.div className="img-wrap" key={doc.id} 
          layout
          whileHover={{ opacity: 1 }}s
          onClick={() => setSelectedImg(doc.url)}
        >
          <motion.img src={doc.url} alt="uploaded pic"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1 }}
          />
        </motion.div>
      ))}
    </div>
  )
}

export default ImageGrid;